export * from './gestion-electronique-documents.component';
export * from './gestion-electronique-documents.module';
